export const determineAchievementMonthsText = (gameDataAchievement, monthCriteria, achievementID,
        nbrMonthsPlayed, processName, monthsPerTurn)=> {
    const gameAchievement = gameDataAchievement.find(elem => elem.achievementID === achievementID);
    let actualMonths = 0;
    let monthText = "";
    let textObj = "";
  
    if (monthCriteria.monthType === "consecutive"){
        if (gameAchievement && gameAchievement.actualMonths){
            actualMonths = +gameAchievement.actualMonths;
        }else{
            actualMonths = 0;
        }
        if (processName === "endOfTurn"){
              actualMonths = +actualMonths + +monthsPerTurn;
        }
        if (monthCriteria.nbrMonths <= 24){
            monthText = "You have met this condition for " + actualMonths + " month(s). " 
        }else{
            let actualYears = 0; 
            const remainder = actualMonths % 12;
            actualYears = actualMonths / 12;
            if (remainder !== 0){
              actualYears = actualYears.toFixed(1);
            }
            monthText = "You have met this condition for " + actualYears + " year(s)." 
        }
    }
    if (monthCriteria.monthType === "monthsPlayed"){
        actualMonths = +nbrMonthsPlayed;
        if (monthCriteria.nbrMonths <= 12){
          monthText = "You have played the game for " + actualMonths + " month(s). " 
        }else{
          let actualYears = 0; 
          const remainder = actualMonths % 12;
          if (remainder !== 0){
             actualYears = (actualMonths / 12).toFixed(1);
          }else{
             actualYears = (actualMonths / 12).toFixed(0);
          }
          monthText = "You have played the game for " + actualYears + " year(s)." 
        }
    }
    let textColor = "black";
    let passedMonthCriteria = false;
    if (+actualMonths >= +monthCriteria.nbrMonths){
          textColor = "green";
          passedMonthCriteria = true;
    }
    textObj = {passedMonthCriteria: passedMonthCriteria, textLine: monthText, textColor: textColor,
        actualMonths: actualMonths };
    
    return textObj;
}
export default determineAchievementMonthsText;